import { render, staticRenderFns } from "./UserSetting.vue?vue&type=template&id=e142ffc6&scoped=true&"
import script from "./UserSetting.vue?vue&type=script&lang=js&"
export * from "./UserSetting.vue?vue&type=script&lang=js&"
import style0 from "./UserSetting.vue?vue&type=style&index=0&id=e142ffc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e142ffc6",
  null
  
)

export default component.exports